<template>
    <PDropDown
      class="p-dropdown"
      v-model="clienteId"
      :options="ClientesArray"
      optionLabel="nomeFantasia"
      :filterFields="[
        'razaoSocial',
        'codigoExterno',
        'nomeFantasia',
        'situacao',
        'estadoCidade',
        'cnpj',
      ]"
      :filter="true"
      optionValue="id"
      placeholder="Selecione o Cliente"
      @filter="buscarClientes($event.value)"
      @change="atualizaModel"
    >
      <template #option="slotProps">
        <cliente-dropdown-item
          :dadosCliente="slotProps.option"
        ></cliente-dropdown-item>
      </template>
    </PDropDown>
</template>

<script>
import clienteDropdown from "./cliente-dropdown.js";
export default clienteDropdown;
</script>

<style scoped>
.p-dropdown {
  width: 100%;
}
</style>
